"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FontBuilder = exports.Font = void 0;
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var Font = /** @class */ (function () {
    function Font() {
    }
    Font.isPublishable = function (font) {
        return Font.hasMediaValid(font);
    };
    Font.hasMediaValid = function (font) {
        return core_common_domain_1.Media.isValidWithContentType(font.media, core_common_domain_1.MimeType.OTF);
    };
    Font.withUrl = function (oldFont, newMediaUrl) {
        return __assign(__assign({}, oldFont), { media: core_common_domain_1.Media.withUrl(oldFont.media, newMediaUrl) });
    };
    return Font;
}());
exports.Font = Font;
var FontBuilder = /** @class */ (function () {
    function FontBuilder(font) {
        this.font = font;
    }
    FontBuilder.initialiseWithFont = function (font) {
        return new FontBuilder(font);
    };
    FontBuilder.initialise = function (name) {
        return FontBuilder.initialiseWithFont({
            id: core_common_logic_1.CommonLogic.generateUUIDv4(),
            name: name,
            media: core_common_domain_1.Media.UNDEFINED
        });
    };
    FontBuilder.prototype.withId = function (fontId) {
        this.font.id = fontId;
        return this;
    };
    FontBuilder.prototype.withMedia = function (media) {
        this.font.media = media;
        return this;
    };
    FontBuilder.prototype.getId = function () {
        return this.font.id;
    };
    FontBuilder.prototype.build = function () {
        return this.font;
    };
    FontBuilder.prototype.buildUpdate = function () {
        return {
            name: this.font.name,
            media: this.font.media
        };
    };
    return FontBuilder;
}());
exports.FontBuilder = FontBuilder;
